import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Show } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Marketplace from "@/pages/Marketplace";
import LotDetail from "@/pages/LotDetail";
import Publish from "@/pages/Publish";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Companies from "@/pages/Companies";
import CompanyReview from "@/pages/CompanyReview";
import GriReport from "@/pages/GriReport";
import Transaction from "@/pages/Transaction";
import Verify from "@/pages/Verify";
import CategoryPage from "@/pages/CategoryPage";
import { CalculatorPage } from "@/pages/InfoPages";
import RoleProfile from "@/pages/RoleProfile";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";

const Protected = ({ children }) => (
  <>
    <Show when="signed-in">{children}</Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <ScrollTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/lotes/:id" element={<LotDetail />} />
            <Route path="/categorias/:id" element={<CategoryPage />} />
            <Route path="/perfiles/:slug" element={<RoleProfile />} />
            <Route path="/empresas" element={<Navigate to="/perfiles/generadoras" replace />} />
            <Route path="/transformadores" element={<Navigate to="/perfiles/gestoras" replace />} />
            <Route path="/calculadora" element={<CalculatorPage />} />
            <Route path="/publicar" element={<Protected><Publish /></Protected>} />
            <Route path="/panel" element={<Protected><Dashboard /></Protected>} />
            <Route path="/perfil" element={<Protected><Profile /></Protected>} />
            <Route path="/mis-empresas" element={<Protected><Companies /></Protected>} />
            <Route path="/mis-empresas/:id" element={<Protected><CompanyReview /></Protected>} />
            <Route path="/mis-empresas/:id/gri-306" element={<Protected><GriReport /></Protected>} />
            <Route path="/transacciones/:id" element={<Protected><Transaction /></Protected>} />
            <Route path="/verificar/:code" element={<Verify />} />
            <Route path="/sign-in/*" element={<SignInPage />} />
            <Route path="/sign-up/*" element={<SignUpPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <Toaster position="top-center" richColors />
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
